import { render, staticRenderFns } from "./Peer.vue?vue&type=template&id=87d75b52"
import script from "./Peer.vue?vue&type=script&lang=js"
export * from "./Peer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports